import jwtInterceoptor from "../components/shared/jwtInterceptor";
import {baseURL} from "../services/api";
import moment from "moment";

/**
 * version 02 to get compta ec
 * @param invoice
 * @returns {{compte_fournisseur: string, sous_compte, total_ttc: number, libelle_fournisseur: *, compte_compte_de_charge: *[], total_ht_et_tva: *[], invoice_type: string, from: string, compte_tva: *[], no_piece: string, date_creation: string}}
 */
export const getEcEcoV2 = (invoice) =>{
    let flux_economique = {};
    let le_compte_fournisseur = '';
    let type_de_compte = '';
    let type_de_taxe = '';
    let items_type = '';
    let is_f_depense = false;
    let total_ttc = 0;
    let invoice_type = '';
    let dataLength = [];
    let tTva = 0
    if (invoice.type === 'achat') {
        dataLength = invoice.product.length;
        total_ttc = invoice.total_ttc;
        tTva = invoice.total_tva;
        invoice_type = 'achat';
        items_type = 'product';        
        le_compte_fournisseur = '4411000';
        type_de_compte = 'purchase_account';
        type_de_taxe = 'taxe_achat';
    } else if (invoice.type === 'vente' || invoice.type === 'avoir') {
        // rendre les mnt négative si facture d'avoir
        let valOperator = invoice.type === 'avoir' ? -1 : 1;
        dataLength = invoice.products.length;
        invoice_type = 'vente';
        total_ttc = invoice.total_ttc * valOperator;
        tTva = invoice.total_tva* valOperator;
        items_type = 'product';
        le_compte_fournisseur = '34210000';
        type_de_compte = 'sales_account';
        type_de_taxe = 'taxe_vente';
    } else if (invoice.type === 'depense') {
        dataLength = invoice.accounts.length;
        invoice_type = 'depense';
        total_ttc = invoice.total_ttc;
        tTva = invoice.total_tva;
        is_f_depense = true;
        items_type = 'account';
        le_compte_fournisseur = '4411000';
        type_de_compte = 'purchase_account';
        type_de_taxe = 'tva';
    }

    let invoiceTvas=[];
    let InvoiceAccounts = [];
    let total_hts = [];
    let total_tvas = [];
    let total_tva = 0;



    for (let index = 0; index < dataLength; index++) {
        if (is_f_depense) {
            InvoiceAccounts.push(invoice['accounts'][index][items_type]['code']);
            invoiceTvas.push(invoice['accounts'][index][type_de_taxe]['code']);
            total_hts.push(invoice['accounts'][index].total_ht);
            total_tva = parseFloat(invoice['accounts'][index].total_ht) * parseFloat(invoice['accounts'][index][type_de_taxe]['rate']).toFixed(2);
            total_tvas.push((total_tva / 100).toFixed(2));
            // total_tva = tTva.toFixed(2);
            // total_tvas.push(total_tva);

        } else {
            let itemType = "";
            // rendre les mnt négative si facture d'avoir
            let operator = 0;
            if (invoice.type === 'vente' || invoice.type === 'avoir') {
                itemType = "products";
                operator = invoice.type === 'avoir' ? -1 : 1;
            } else {
                operator = 1;
                itemType = "product";
            }

            InvoiceAccounts.push(invoice[itemType][index]['product'][type_de_compte]['code']);
            invoiceTvas.push(invoice[itemType][index]['product'][type_de_taxe]['code']);
// Pushing total without tax
total_hts.push(parseFloat(invoice[itemType][index].total_ht) * operator);

// Calculating total TVA (tax amount)
total_tva = (parseFloat(invoice[itemType][index].qty) * parseFloat(invoice[itemType][index].price_unit_ht) * parseFloat(invoice[itemType][index].tva) / 100).toFixed(2);

// Pushing total TVA with operator
total_tvas.push((parseFloat(total_tva) * operator).toFixed(2));

            // total_tva = tTva.toFixed(2);
            // total_tvas.push(total_tva);
        }
    }

    flux_economique = {
        date_creation: moment(invoice.created_at).format("DD/MM/YYYY"),
        invoice_number: invoice.invoice_number,
        no_piece: invoice.type === 'avoir' ? 'FAV' + '' + invoice.id : invoice.type.charAt(0) + '' + invoice.id,
        compte_fournisseur: le_compte_fournisseur,
        compte_tva: invoiceTvas,
        compte_compte_de_charge: InvoiceAccounts,
        sous_compte: invoice.client.account.code,
        libelle_fournisseur: invoice.client.companyName,
        total_ttc: total_ttc,
        total_ht_et_tva: ['<br />', ...total_tvas, ...total_hts],
        invoice_type: invoice_type,
        from: 'invoice_module'
    };
    return flux_economique;
}

///////
/**
 *
 * @param invoice
 * @param dateFrom: in case I want to filter by date
 * @param dateTo: in case I want to filter by date
 * @param filterByDate: true or false, if true lets get dateFrom and dateTo
 * @return {*[]}
 */
    export const getEcFinV2 = (invoice,dateFrom=null,dateTo=null,filterByDate=false) =>{
    let le_compte_fournisseur = '';
    let api_endpoint_for_invoice_history = '';
    let invoice_type = '';
    let total_ttc = 0;
    let dataLength = [];
    // rendre les mnt négative si facture d'avoir
    let operator = 0;

    if (invoice.type === 'achat') {
        operator=1;
        invoice_type = 'achat';
        le_compte_fournisseur = '4411000';
    } else if (invoice.type === 'vente' || invoice.type === 'avoir') {
        operator = invoice.type === 'avoir' ? -1 : 1;
        invoice_type = 'vente';
        le_compte_fournisseur = '34210000';
    } else if (invoice.type === 'depense') {
        operator=1;
        invoice_type = 'depense';
        le_compte_fournisseur = '4411000';
    }

    let flux_financier = [];
    let elt = {};
    let payedAmounts = 0;
    let letTotalhtFluxFin = 0;
    let condition=true;

    for (let i = 0; i < invoice.payment.length; i++) {
        let dateCreatedAt = new Date(invoice['payment'][i].created_at);
        if (!filterByDate) {
            condition = true;
        } else {
            condition = dateCreatedAt >= dateFrom && dateCreatedAt <= dateTo;
        }

        if ([2, 3].includes(invoice['payment'][i]['status']['id']) && condition) {
            payedAmounts += parseFloat(invoice['payment'][i]['payed_amount']);

            if (i === 0 && invoice['payment'][i]['status']['id'] === 2) {
                //condition 1, is paid from the first creation
                letTotalhtFluxFin = invoice.total_ttc;
            } else if (i > 0 && invoice['payment'][i]['status']['id'] === 2) {
                //condition 2, is paid from the x iteration
                letTotalhtFluxFin = parseFloat(invoice.total_ttc) - payedAmounts;
            } else {
                //condition 3, if not paid yet
                letTotalhtFluxFin = invoice['payment'][i]['payed_amount'];
            }

            //if mantant_paye is setted, total_ttc = matant_paye
            elt = {
                date_creation: moment(invoice['payment'][i].created_at).format("DD/MM/YYYY"),
                no_piece: invoice.type === 'avoir' ? 'FAV' + '' + invoice.id : invoice.type.charAt(0) + '' + invoice.id,
                invoice_number: invoice.invoice_number,
                compte_fournisseur: le_compte_fournisseur,
                sous_compte: invoice.client.account.code,
                payment_account: invoice['payment'][i]['payment_account']['code'],
                banquePaymentOption: invoice['payment'][i]['banquePaymentOption'] === null ? "" : invoice['payment'][i]['banquePaymentOption'],
                chequeId: invoice['payment'][i]['chequeId'] === null ? "" : invoice['payment'][i]['chequeId'],
                libelle_fournisseur: invoice.client.companyName,
                invoice_type: invoice_type,
                total_ttc: letTotalhtFluxFin * operator
            };
            flux_financier.push(elt);
        }
    }
    return flux_financier;
}

/**
 * le_compte_fournisseur : could be compte fournisseur as well as compte client
 *
 * @param invoice
 * @param isGrandLivre
 * @param accounts_code
 * @returns {Promise<*|{compte_fournisseur: string, sous_compte, total_ttc: number, libelle_fournisseur: string, compte_compte_de_charge: *[], total_ht_et_tva: *[], invoice_type: string, compte_tva: *[], no_piece, date_creation: string}>}
 */
export const getEcEco = async (invoice, isGrandLivre = false, accounts_code = '') => {
    let le_compte_fournisseur = '';
    let type_de_compte = '';
    let type_de_taxe = '';
    let api_endpoint_for_products = '';
    let items_type = '';
    let flux_economique = {};
    let is_f_depense = false;
    let total_ttc = 0;
    let invoice_type = '';

    if (invoice.type === 'achat') {
        total_ttc = invoice.total_ttc;
        invoice_type = 'achat';
        items_type = 'product';
        le_compte_fournisseur = '4411000';
        type_de_compte = 'purchase_account';
        type_de_taxe = 'taxe_achat';
        api_endpoint_for_products = 'facture_achats_products';
    } else if (invoice.type === 'vente') {
        invoice_type = 'vente';
        total_ttc = invoice.total_ttc;
        items_type = 'product';
        le_compte_fournisseur = '34210000';
        type_de_compte = 'sales_account';
        type_de_taxe = 'taxe_vente';
        api_endpoint_for_products = 'facture_products';
    } else if (invoice.type === 'depense') {
        invoice_type = 'depense';
        total_ttc = invoice.total_ttc;
        is_f_depense = true;
        items_type = 'account';
        le_compte_fournisseur = '4411000';
        type_de_compte = 'purchase_account';
        type_de_taxe = 'tva';
        api_endpoint_for_products = 'facture_depense_accounts';
    }

    return await jwtInterceoptor.get(baseURL + `/data/user/${api_endpoint_for_products}/${invoice.id}`)
        .then((re) => {
            let invoiceTvas = [];
            let InvoiceAccounts = [];
            let credit = [];
            let total_hts = [];
            let total_tvas = [];
            let total_tva = 0;
            let is_debit = false;
            let is_credit = false;
            let total_ttc_account_for_gl = 0;

            for (let i = 0; i < re.data.data.length; i++) {
                if (is_f_depense) {
                    if (isGrandLivre && re.data.data[i][items_type]['code'] === accounts_code) {
                        is_credit = invoice_type === 'vente';
                        is_debit = invoice_type !== 'vente';
                        total_ttc_account_for_gl = re.data.data[i]['total_ht'];
                    }
                    InvoiceAccounts.push(re.data.data[i][items_type]['code']);
                    invoiceTvas.push(re.data.data[i][type_de_taxe]['code']);
                    total_hts.push(re.data.data[i]['total_ht']);
                    total_tva = parseFloat(re.data.data[i]['total_ht']) * parseFloat(re.data.data[i]['tva']['rate']);
                    total_tvas.push(total_tva / 100);
                } else {
                    if (isGrandLivre && re.data.data[i][items_type][type_de_compte]['code'] === accounts_code) {
                        is_credit = invoice_type === 'vente';
                        is_debit = invoice_type !== 'vente';
                        total_ttc_account_for_gl = re.data.data[i]['total_ht'];
                    }
                    InvoiceAccounts.push(re.data.data[i][items_type][type_de_compte]['code']);
                    invoiceTvas.push(re.data.data[i][items_type][type_de_taxe]['code']);
                    total_hts.push(re.data.data[i]['total_ht']);
                    total_tva = (parseFloat(re.data.data[i]['qty']) * parseFloat(re.data.data[i]['price_unit_ht'])) * parseFloat(re.data.data[i]['tva']);
                    total_tvas.push(total_tva / 100);
                }
            }

            if (isGrandLivre) {
                flux_economique = {
                    code: accounts_code,
                    date_creation: moment(invoice.created_at).format("DD/MM/YYYY"),
                    no_piece: invoice.id,
                    debit: is_debit,
                    credit: is_credit,
                    total_ht: total_ttc_account_for_gl,
                    invoice_type: invoice_type,
                    from: 'piece_module'
                };
            } else {
                flux_economique = {
                    date_creation: moment(invoice.created_at).format("DD/MM/YYYY"),
                    no_piece: invoice.type.charAt(0) + '' + invoice.id,
                    compte_fournisseur: le_compte_fournisseur,
                    compte_tva: invoiceTvas,
                    compte_compte_de_charge: InvoiceAccounts,
                    sous_compte: invoice.client.account.code,
                    libelle_fournisseur: invoice.client.companyName,
                    total_ttc: total_ttc,
                    total_ht_et_tva: ['<br />', ...total_tvas, ...total_hts],
                    invoice_type: invoice_type,
                    from: 'invoice_module'
                };

            }
            return flux_economique;
        })
        .catch((error) => {
            return error;
        })
}
/**
 * get new ec registered in the last step ocr
 *
 * @param invoice
 * @returns {Promise<*|axios.AxiosResponse<any>>}
 */
export const getPieceLier = async (invoice) => {
    return await jwtInterceoptor.get(baseURL + `/data/user/piece/invoice/${invoice.id}/${invoice.type}`)
        .then((re) => {
            console.log("res : ", re.data.data)
            if (re.data.data.length === 0) {
                return null;
            }
            let accounts = [];
            let debit = [];
            let credit = [];
            let le_compte_fournisseur = '';

            if (invoice.type === 'achat') {
                le_compte_fournisseur = '4411000';
            } else if (invoice.type === 'vente') {
                le_compte_fournisseur = '34210000';
            } else if (invoice.type === 'depense') {
                le_compte_fournisseur = '4411000';
            }

            for (let i = 0; i < re.data.data[0]['debit_credit'].length; i++) {
                accounts.push(re.data.data[0]['debit_credit'][i]["account"]["code"]);
                debit.push(re.data.data[0]['debit_credit'][i]["debit"]);
                credit.push(re.data.data[0]['debit_credit'][i]["credit"]);
            }

            /**
             *
             * @type {{compte_fournisseur: string, libelle_fournisseur: string, from: string, accounts: *[][], no_piece: (null|*), debit: *[][], credit: *[][], date_creation: string}}
             */
            let fluxPiece = {
                date_creation: moment(re.data.data.created_at).format("DD/MM/YYYY"),
                no_piece: 'P'+re.data.data[0].invoice_id,
                compte_fournisseur: le_compte_fournisseur,
                accounts: [accounts],
                debit: [debit],
                credit: [credit],
                from: 'ocr_ec_module',
                libelle_fournisseur: '-'
            };
            console.log("fluxPiece ff : ", fluxPiece)

            return fluxPiece;
        })
        .catch((error) => {
            return error;
        })
}

export const getPieceLierV2 = (invoice) => {
    let accounts = [];
    let debit = [];
    let credit = [];
    let le_compte_fournisseur = '';

    if (invoice.type === 'achat') {
        le_compte_fournisseur = '4411000';
    } else if (invoice.type === 'vente') {
        le_compte_fournisseur = '34210000';
    } else if (invoice.type === 'depense') {
        le_compte_fournisseur = '4411000';
    }

    if( invoice['piece']!=null ){
        for (let i = 0; i < invoice['piece']['debit_credit'].length; i++) {
            accounts.push(invoice['piece']['debit_credit'][i]['account'].code);
            console.log("invoice['piece']['debit_credit'][i]['account'].code",invoice['piece']['debit_credit'][i]['account'].code);
            debit.push(invoice['piece']['debit_credit'][i]['debit']);
            credit.push(invoice['piece']['debit_credit'][i]['credit']);
        }

        let fluxPiece = {
            date_creation: moment(invoice.created_at).format("DD/MM/YYYY"),
            no_piece: 'P'+invoice.id,
            compte_fournisseur: le_compte_fournisseur,
            accounts: [accounts],
            debit: [debit],
            credit: [credit],
            from: 'ocr_ec_module',
            libelle_fournisseur: '-'
        };
        console.log('fluxPiece: fluxPiece : ',fluxPiece);
        return fluxPiece;
    }else{
        return null;
    }
}

/**
 * get pieces created in the piece module
 *
 * @param piece
 * @param isBqOrCs {Boolean} : if is bq or cs sc returned flux format is different
 * @returns {Promise<{compte_fournisseur: string, libelle_fournisseur: (string|*), from: string, accounts: *[][], no_piece: string, debit: *[][], credit: *[][], date_creation: string}>}
 */
export const getPieceEc = (piece,isBqOrCs=false) => {
    let accounts = [];
    let debit = [];
    let credit = [];

    for (let i = 0; i < piece['debit_credit'].length; i++) {
        accounts.push(piece['debit_credit'][i]["account"]["code"]);
        debit.push(piece['debit_credit'][i]["debit"]);
        credit.push(piece['debit_credit'][i]["credit"]);
    }

    /**
     *
     * @type {{Object}}
     */
    let fluxPiece = {};

    if (isBqOrCs) {
        fluxPiece = {
            date_creation: moment(piece.created_at).format("DD/MM/YYYY"),
            no_piece: 'P' + (piece.invoice_id === null ? piece.id : piece.invoice_id),
            compte_fournisseur: '',
            libelle_fournisseur: piece.libelle,
            accounts: [accounts],
            debit: [debit],
            credit: [credit],
            from: 'piece_module',
            isSousCompteBqCs: true
        };
    } else {
        fluxPiece = {
            date_creation: moment(piece.created_at).format("DD/MM/YYYY"),
            no_piece: 'P' + (piece.invoice_id === null ? piece.id : piece.invoice_id),
            compte_fournisseur: '',
            libelle_fournisseur: piece.libelle,
            accounts: [accounts],
            debit: [debit],
            credit: [credit],
            from: 'piece_module',
            isSousCompteBqCs: false
        };
    }

    return fluxPiece;
}

/**
 * le_compte_fournisseur : could be compte fournisseur as well as compte client
 *
 * @param invoice
 * @returns {Promise<*|*[]>}
 */
export const getEcFin = async (invoice) => {
    let le_compte_fournisseur = '';
    let api_endpoint_for_invoice_history = '';
    let invoice_type = '';
    let total_ttc = 0;

    if (invoice.type === 'achat') {
        total_ttc = invoice.total_ttc;
        invoice_type = 'achat';
        le_compte_fournisseur = '4411000';
        api_endpoint_for_invoice_history = 'invoice_achats_status_history';
    } else if (invoice.type === 'vente') {
        total_ttc = invoice.total_ttc;
        invoice_type = 'vente';
        le_compte_fournisseur = '34210000';
        api_endpoint_for_invoice_history = 'invoice_status_history';
    } else if (invoice.type === 'depense') {
        total_ttc = invoice.total_ttc;
        invoice_type = 'depense';
        le_compte_fournisseur = '4411000';
        api_endpoint_for_invoice_history = 'invoice_depense_status_history';
    }

    return await jwtInterceoptor.get(baseURL + `/data/user/${api_endpoint_for_invoice_history}/${invoice.id}`)
        .then((re) => {
            let flux_financier = [];
            let elt = {};
            let payedAmounts = 0;
            let letTotalhtFluxFin = 0;

            for (let i = 0; i < re.data.data.length; i++) {
                if ([2, 3].includes(re.data.data[i]['status']['id'])) {
                    payedAmounts += parseFloat(re.data.data[i]['payed_amount']);

                    if (i === 0 && re.data.data[i]['status']['id'] === 2) {
                        //condition 1, is paid from the first creation
                        letTotalhtFluxFin = invoice.total_ttc;
                    } else if (i > 0 && re.data.data[i]['status']['id'] === 2) {
                        //condition 2, is paid from the x iteration
                        letTotalhtFluxFin = parseFloat(invoice.total_ttc) - payedAmounts;
                    } else {
                        //condition 3, if not paid yet
                        letTotalhtFluxFin = re.data.data[i]['payed_amount'];
                    }

                    //if mantant_paye is setted, total_ttc = matant_paye
                    elt = {
                        date_creation: moment(re.data.data[i].created_at).format("DD/MM/YYYY"),
                        no_piece: invoice.type.charAt(0) + '' + invoice.id,
                        compte_fournisseur: le_compte_fournisseur,
                        sous_compte: invoice.client.account.code,
                        payment_account: re.data.data[i]['payment_account']['code'],
                        banquePaymentOption: re.data.data[i]['banquePaymentOption'],
                        chequeId: re.data.data[i]['chequeId'],
                        libelle_fournisseur: invoice.client.companyName,
                        invoice_type: invoice_type,
                        total_ttc: letTotalhtFluxFin
                    };
                    flux_financier.push(elt);
                }
            }

            return flux_financier;
        })
        .catch((error) => {
            return error;
        })
}